import Marquee from "react-fast-marquee";

const WORDS = ["REGULATE", "REWIRE", "RADIATE"];

export const Ribbon = () => (
  <section
    className="relative z-10 border-y border-white/10 py-5 md:py-6"
    data-testid="marquee-section"
  >
    <Marquee speed={34} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-xl font-light tracking-[0.2em] text-white/90 md:text-2xl">
            {w}
          </span>
          <span className="mx-6 font-display text-xl font-light text-white/40 md:mx-8 md:text-2xl">
            .
          </span>
        </div>
      ))}
    </Marquee>
  </section>
);
